<script setup lang="ts">
const { items, active } = useNavItems();
</script>

<template>
  <nav class="sidebar">
    <div class="list">
      <template v-for="item in items" :key="item.label">
        <RouterLink
          class="item"
          :href="route(item.route)"
          :class="{ active: active(item.route) }"
          :tabindex="active(item.route) ? '-1' : '0'"
        >
          <i :class="item.icon" />
          <span>{{ item.label }}</span>
        </RouterLink>
      </template>
    </div>
  </nav>
</template>

<style scoped>
.sidebar {
  min-width: 244px;
}

.sidebar .list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  padding: var(--spacing-10);
  border: 1px solid var(--color-stroke-soft-200);
  border-radius: var(--radius-16);
  background: var(--color-bg-white-0);
  box-shadow: var(--shadow-regular-xs);
  gap: var(--spacing-8);
}

.sidebar .list .item {
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: var(--spacing-8);
  transition: all var(--animation-fast) ease;
  border-radius: var(--radius-8);
  background: var(--color-bg-white-0);
  color: var(--color-text-sub-600);
  font: var(--label-sm);
  text-decoration: none;
  gap: var(--spacing-6);
}

.sidebar .list .item i {
  flex-shrink: 0;
  width: 1lh;
  height: 1lh;
}

.sidebar .list .item.active {
  background: var(--color-bg-weak-50);
  color: var(--color-text-strong-950);
  cursor: default;
  pointer-events: none;
}

.sidebar .list .item:not(.active):is(:hover) {
  background: var(--color-bg-weak-50);
}

.sidebar .list .item:not(.active):is(:focus, :active) {
  box-shadow: var(--shadow-buttons-important-focus);
}
</style>
